export const ADD_GL_CODE_FAILED_NOTIFICATION = 'Unable to add new GL code'
export const ADD_GL_CODE_SUCCEEDED_NOTIFICATION = 'GL Code successfully created'

export const API_TIMEOUT_ERROR_NOTIFICATION = `An error occurred, please try again.`

export const UPDATE_USER_FAILED_NOTIFICATION = 'Unable to update user'
export const UPDATE_USER_SUCCEEDED_NOTIFICATION = 'User updated'

export const REGISTER_USER_FAILED_NOTIFICATION = 'Something went wrong, please try again'

export const UPDATE_RECEIPT_FAILED_NOTIFICATION = 'Unable to update expense record'

export const UPDATE_RECEIPT_SUCCEEDED_NOTIFICATION = 'Expense record updated'

export const UPDATE_VENDOR_FAILED_NOTIFICATION = 'Unable to update vendor'
export const UPDATE_VENDOR_SUCCEEDED_NOTIFICATION = 'Vendor updated'

export const ADD_VENDOR_ALIAS_FAILED_NOTIFICATION = 'Unable to add vendor alias'
export const ADD_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION = 'Vendor alias added'

export const CREATE_USER_INBOX_FAILED_NOTIFICATION = 'Unable to create user inbox'
export const CREATE_USER_INBOX_SUCCEEDED_NOTIFICATION = 'Inbox created'

export const CREATE_LEDGER_RECORD_FAILED_NOTIFICATION = 'Unable to create document'
export const CREATE_LEDGER_RECORD_SUCCEEDED_NOTIFICATION = 'Document created'

export const DELETE_LEDGER_RECORD_FAILED_NOTIFICATION = 'Unable to delete document'
export const DELETE_LEDGER_RECORD_SUCCEEDED_NOTIFICATION = 'Document deleted'

export const CHANGE_VENDOR_ALIAS_FAILED_NOTIFICATION = 'Unable to update vendor alias'
export const CHANGE_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION = 'Vendor alias updated'

export const DELETE_VENDOR_ALIAS_FAILED_NOTIFICATION = 'Unable to delete vendor alias'
export const DELETE_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION = 'Vendor alias deleted'

export const ADD_VENDOR_GL_CODE_FAILED_NOTIFICATION = 'Unable to add GL code for vendor'
export const ADD_VENDOR_GL_CODE_SUCCEEDED_NOTIFICATION = 'Vendor GL code added'

export const CHANGE_VENDOR_GL_CODE_FAILED_NOTIFICATION = 'Unable to update vendor GL code'
export const CHANGE_VENDOR_GL_CODE_SUCCEEDED_NOTIFICATION = 'Vendor GL code updated'

export const DELETE_VENDOR_GL_CODE_FAILED_NOTIFICATION = 'Unable to delete vendor GL code'
export const DELETE_VENDOR_GL_CODE_SUCCEEDED_NOTIFICATION = 'Vendor GL code deleted'

export const GENERATE_REPORT_FAILED_NOTIFICATION = 'Unable to generate report'

export const ADD_VENDOR_EXPENSE_CATEGORY_FAILED_NOTIFICATION = 'Unable to add expense category'

export const ADD_VENDOR_EXPENSE_CATEGORY_SUCCEEDED_NOTIFICATION = 'Vendor expense category added'

export const CHANGE_VENDOR_EXPENSE_CATEGORY_FAILED_NOTIFICATION =
  'Unable to update expense category'

export const CHANGE_VENDOR_EXPENSE_CATEGORY_SUCCEEDED_NOTIFICATION =
  'Vendor expense category updated'

export const DELETE_VENDOR_EXPENSE_CATEGORY_FAILED_NOTIFICATION =
  'Unable to delete expense category'

export const DELETE_VENDOR_EXPENSE_CATEGORY_SUCCEEDED_NOTIFICATION = 'Expense category deleted'

export const PASSWORD_UPDATE_SUCCESS_NOTIFICATION = 'Password updated'
export const PASSWORD_UPDATE_FAILED_NOTIFICATION = 'Password update failed'
export const INVALID_FILE_TYPE_NOTIFICATION = 'Invalid file type'

export const ATTACHMENT_ADDED_NOTIFICATION = 'Attachment added'
export const ATTACHMENT_DELETED_NOTIFICATION = 'Attachment deleted'

export const ATTACHMENT_ADD_FAILED_NOTIFICATION = 'Unable to add attachment'
export const ATTACHMENT_DELETE_FAILED_NOTIFICATION = 'Unable to delete attachment'

export const DEFAULT_ERROR = 'Something went wrong, please try again'
export const INVALID_PROMO_CODE_ERROR =
  'You have entered an invalid promo code. Request a new promo code now or reach out to '
export const USER_EXISTS_ERROR_A =
  'An account with this email address already exists in the system. Click here to'
export const USER_EXISTS_ERROR_B = 'please sign in.'
export const RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED_NOTIFICATION =
  'Unable to resend the email. Please try again.'
export const RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED_NOTIFICATION =
  'Email has been sent successfully.'

export const CREATE_VENDOR_SUCCEEDED_NOTIFICATION = 'Vendor successfully created'
export const CREATE_VENDOR_FAILED_NOTIFICATION = 'Unable to create vendor'

export const CREATE_EXPENSE_CATEGORY_SUCCEEDED_NOTIFICATION =
  'Expense category successfully created'
export const CREATE_EXPENSE_CATEGORY_FAILED_NOTIFICATION = 'Unable to create expense category'

export const CREATE_PROPERTY_NAME_SUCCEEDED_NOTIFICATION = 'Property name successfully created'
export const CREATE_PROPERTY_NAME_FAILED_NOTIFICATION = 'Unable to create property name'

export const CREATE_UNIT_NO_SUCCEEDED_NOTIFICATION = 'Unit no successfully created'
export const CREATE_UNIT_NO_FAILED_NOTIFICATION = 'Unable to create unit no'

export const CREATE_REPORT_FAILED_NOTIFICATION = 'Report creation failed, please try again.'
export const DELETE_REPORT_FAILED_NOTIFICATION = 'Unable to delete report, please try again.'
export const UPDATE_REPORT_FAILED_NOTIFICATION = 'Unable to update report, please try again.'
export const RESEND_INVITE_SUCCEED_NOTIFICATION = 'User invite resent'
export const RESEND_INVITE_FAILED_NOTIFICATION = 'Unable to resend invite, please try again.'
export const ADD_USER_FAILED_NOTIFICATION = 'User email is already registered'

export const EXPORT_SYNC_FAILED_NOTIFICATION =
  'An attempt to sync failed. Please try again in a few minutes or contact Itemize support.'

export const EXPORT_SYNC_SUCCEEDED_NOTIFICATION =
  'Data sync is in progress. You will receive an email when it is completed.'
export const SYNC_EXPORT_NO_RECORDS_SELECTED_NOTIFICATION = 'No records selected for sync.'
